const BaseComponent = require('base/base-component')
const Server = require('helper/server')

class ZcyGXTopLine extends BaseComponent {
  constructor () {
    super({
      events: {
        'click #region': 'showSite',
        'click #region-node': 'changeSite'
      }
    })
  }

  init () {
    const date = new Date()
    const hour = date.getHours()
    let _t = ''
    if ((hour <= 24 && hour > 17) || hour < 5) {
      _t = '晚上好，'
    } else if (hour < 12) {
      _t = '上午好，'
    } else if (hour <= 17) {
      _t = '下午好，'
    }
    this.$el.find('.welcome').text(_t)
    Server.visitCount().then(res => {
      const { total = 0} = res
      this.$el.find('.count').text(total)
    });
    Server.regionListApi({
      indexPagePath: 'hunan'
    }).then(res => {
      const ul = this.$el.find('#region-node-ul')
      const { result = []} = res;
      window.REGION = result;
      result.map(x => {
        ul.append(`
        <a href="http://${x.domain}/home.html">
          <li class="region-node">
              ${x.districtName}
          </li>
        </a>`);
        if (window.location.hostname === x.domain) {
          this.$el.find('#region-name').text(x.districtName)
        }
      });
    });
  }
  showSite () {
    const el = this.$el.find('#region')
    const region = this.$el.find('#region-cascader')
    region.toggle()
  }
  changeSite (e) {
    console.log('e', e)
  }
}

module.exports = ZcyGXTopLine
